import { render } from "./ActualizarCollegiates2.vue?vue&type=template&id=1ab66a50&scoped=true"
import script from "./ActualizarCollegiates2.vue?vue&type=script&lang=js"
export * from "./ActualizarCollegiates2.vue?vue&type=script&lang=js"

import "./ActualizarCollegiates2.vue?vue&type=style&index=0&id=1ab66a50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab66a50"]])

export default __exports__